import { useState } from 'react';
import {
  SortingState,
  ColumnFiltersState,
  RowSelectionState,
  PaginationState,
  OnChangeFn,
} from '@tanstack/react-table';

type Parameter = {
  sortingState?: [SortingState, OnChangeFn<SortingState>];
  filteringState?: [ColumnFiltersState, OnChangeFn<ColumnFiltersState>];
  rowSelectionState?: [RowSelectionState, OnChangeFn<RowSelectionState>];
  paginationState: [PaginationState, OnChangeFn<PaginationState>];
};

type Return = {
  sorting: SortingState;
  setSorting: OnChangeFn<SortingState>;
  filtering: ColumnFiltersState;
  setFiltering: OnChangeFn<ColumnFiltersState>;
  rowSelection: RowSelectionState;
  setRowSelection: OnChangeFn<RowSelectionState>;
  pagination: PaginationState;
  setPagination: OnChangeFn<PaginationState>;
};

/**
 * @note 외부에서 Control 하지 않는 클라이언트의 정렬이나 필터링이 사용할때 사용합니다.
 */
export const useTableClientState = ({
  sortingState,
  filteringState,
  rowSelectionState,
  paginationState,
}: Parameter): Return => {
  const [sorting, setSorting] = useState<SortingState>(sortingState?.[0] ?? []);
  const [filtering, setFiltering] = useState<ColumnFiltersState>(filteringState?.[0] ?? []);
  const [rowSelection, setRowSelection] = useState<RowSelectionState>(rowSelectionState?.[0] ?? {});
  const [pagination, setPagination] = useState(paginationState[0]);

  return {
    sorting,
    setSorting,
    filtering,
    setFiltering,
    rowSelection,
    setRowSelection,
    pagination,
    setPagination,
  };
};
